import { createContext, FC, useContext } from 'react';

const RowIndexContext = createContext(0);

export const useRowIndex = () => useContext(RowIndexContext);

type RowProps = {
  index: number;
};

export const Row: FC<React.PropsWithChildren<RowProps>> = ({ index, children }) => (
  <RowIndexContext.Provider value={index}>
    <>{children}</>
  </RowIndexContext.Provider>
);
